import { HtsButtonIcon, HtslIcon } from '@hts/shared/ui';
import { SwipeableDrawer } from '@mui/material';
import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../../styles/Header/Mobile/SearchMenu.module.scss';
import { SearchForm } from '../../SearchForm';

interface ISearchMenuProps {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const SearchMenu: React.FC<ISearchMenuProps> = memo(({ isOpen, onClose, onOpen }) => {
  const navigate = useNavigate();

  const onCloseSearchForm = useCallback(
    (redirectTo?: string) => {
      if (redirectTo) {
        onClose();
        navigate(redirectTo);
      }
    },
    [navigate, onClose]
  );

  return (
    <SwipeableDrawer
      anchor="top"
      open={isOpen}
      SlideProps={{ className: styles.slideContainer }}
      onOpen={onOpen}
      onClose={onClose}
    >
      <div className={styles.topContainer}>
        <HtsButtonIcon onClick={onClose}>
          <HtslIcon icon="keyboard-backspace-left" className={styles.backspaceIcon} />
        </HtsButtonIcon>

        <SearchForm onClose={onCloseSearchForm} />
      </div>

      <div className={styles.contentContainer}></div>
    </SwipeableDrawer>
  );
});
